import React from 'react';
import dayjs from "dayjs";
import 'dayjs/locale/cs';
import {Race} from "../../../schemas/races/racesSchema";
import {IconButton, List, ListItem, ListItemText, Typography} from "@mui/material";
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import {InfoOutlined} from "@mui/icons-material";

interface RaceListProps {
    races: Race[] | undefined;
}

const RacesList: React.FC<RaceListProps> = ({races}) => {
    return (
        <List sx={{width: '100%'}}>
            <Typography variant="h6" sx={{textAlign: 'center', mb: 1}}>Seznam závodů</Typography>
            {races && races.length > 0 ? (
                races
                    .sort((r1, r2) => {
                        const date1 = dayjs(r1.date);
                        const date2 = dayjs(r2.date);
                        return date1.isBefore(date2) ? -1 : date1.isAfter(date2) ? 1 : 0;
                    })
                    .map(race => {
                    const isPast = dayjs().isAfter(dayjs(race.date));
                    console.log(isPast);
                    return (
                        <ListItem key={race.id} sx={{pb: 0, pt: 0}}>
                            {isPast ? (
                                <AccessTimeIcon sx={{color: 'orange', marginRight: 1}}/>
                            ) : (
                                <EventAvailableIcon sx={{color: 'green', marginRight: 1}}/>
                            )}
                            <ListItemText
                                primary={
                                    <Typography variant="body2">
                                        {race.name}
                                    </Typography>
                                }
                                secondary={
                                    <Typography variant="caption">
                                        {dayjs(race.date).format('DD.MM.YYYY')}
                                    </Typography>
                                }
                            />
                            {race.publishStatus === "PUBLISHED" && (
                                <IconButton sx={{ml: 'auto', color: 'primary.main'}} title="Více informací" onClick={
                                    () => document.getElementById(`race-${race.id}`)?.scrollIntoView({
                                        behavior: 'smooth',
                                        block: 'start',
                                    })
                                }>
                                    <InfoOutlined/>
                                </IconButton>
                            )}
                        </ListItem>
                    );
                })
            ) : (
                <Typography variant="body2" sx={{textAlign: 'center', color: "red"}}>
                    Žádné závody k zobrazení.
                </Typography>
            )}
        </List>
    );
};

export default RacesList;